import React from "react";
import {localField} from "../../../../_ae/helpers/UIHelper";
import {fetchVendorsForSelect, useVendorsForSelect} from "../../../../redux/vendors";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";

export const Field = ({...props}) => {
  const dispatch = useDispatch();
  const {data, isLoading, metadata} = useVendorsForSelect()

  const handleSearch = search => {
    dispatch(
      fetchVendorsForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name="vendor"
      label={'VENDOR'}
      options={data}
      getOptionLabel={option=>option.name}
      onOpen={()=>{
        handleSearch('')
      }}
      onInputChange={(event, search) => {
        handleSearch(search)
      }}
      loading={isLoading}
      {...props}
    />
  )
}